<template>
  <div class="success">{{text}}</div>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
.success {
  border-radius: 5px;
  color: #fff;
  background: #64d282;
  font-size: 17px;
  padding: 10px;
  text-align: center;
  margin-top: 15px;
}
</style>